import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import SideNavLayout from "../../Sidenav/SideNavLayout";
import { useNavigate } from "react-router-dom";
import {
  calendericonblack,
  eyeiconwhite,
  plusicongrey,
} from "../../utils/svgs/svgs";
import api from "../../api/api";
import dayjs from "dayjs";

// MUI
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import EmployeePhotoModal from "./employeephotomodal";
import RefreshIcon from '@mui/icons-material/Refresh';
// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import ToastMessage from "../../utils/muitoast";
import DeleteConfirmModal from "../modals/deleteconformationmodal";

const OnBoardingView = () => {
  const navigate = useNavigate();
  const pickerRef = useRef(null);
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState([]);
 const user = useSelector((state) => state.user.userDetails);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [companyies, setCompanyies] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
 const [openToast, setOpenToast] = useState(false); // Toast visibility
  const [toastMessage, setToastMessage] = useState(''); // Message to show in Toast
  const [toastSeverity, setToastSeverity] = useState('error'); 
  // search state
  const [activeSearchField, setActiveSearchField] = useState(null);
  const [searchId, setSearchId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [selectedFilter, setSelectedFilter] = useState(null);
const [deleteModalOpen, setDeleteModalOpen] = useState(false);
const [deleteEmployeeId, setDeleteEmployeeId] = useState(null);

  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  // Date filter state
  const [historyCalendar, setHistoryCalendar] = useState(null); // applied filter
  const [selectionRange, setSelectionRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [showPicker, setShowPicker] = useState(false);
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
 setOpenToast(false);
  };
  // Handle outside click to close calendar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const company = await api.get(`/v1/timesheets/company-details`);
      // if (company.status === 200) {
      //   setCompanyies(company.data || []);

      // }
if (company.status === 200) {
  const allCompanies = company.data || [];
  let finalCompanies = allCompanies;



  if (user.user_roles?.role== "Supervisor") {
    const matchedCompany = allCompanies.find(
      c => c.id == user?.user_info?.company_id
    );
    finalCompanies = matchedCompany ? [matchedCompany] : [];
  }

  setCompanyies(finalCompanies);
}

      let url = `/v1/onboarding-employee/get_all_details`;
      if (startDate && endDate) {
        url += `?start_date=${startDate}&end_date=${endDate}`;
      }

      const response = await api.get(url);
      // if (response.status === 200) {
      //   setEmployees(response.data || []);
      //   setFilteredEmployees(response.data || []);
      // }
      if (response.status === 200) {
  const allEmployees = response.data || [];
  let finalEmployees = allEmployees;

  

  if (
    user?.user_roles?.role === "Supervisor"
  ) {
    finalEmployees = allEmployees.filter(
      emp => emp?.employee_details?.supervisorid === user?.phone
    );
  }

  setEmployees(finalEmployees);
  setFilteredEmployees(finalEmployees);
}

      else {
        setEmployees([]);
        setFilteredEmployees([]);
      }
      setCurrentPage(1);
    } catch (error) {
      console.log("error while fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApply = () => {
    setHistoryCalendar(selectionRange);
    setShowPicker(false);

    const startDate = dayjs(selectionRange[0].startDate).format("YYYY-MM-DD");
    const endDate = dayjs(selectionRange[0].endDate).format("YYYY-MM-DD");

    fetchData(startDate, endDate);
  };

  const handleReset = () => {
    setHistoryCalendar(null);
    setShowPicker(false);
    fetchData(); // fetch without date
  };

  // initial fetch (no date filter)
  useEffect(() => {
    fetchData();
  }, []);

  const handleOpenPhotos = (images) => {
    setSelectedPhotos(images || []);
    setPhotoModalOpen(true);
  };
  const handleClosePhotos = () => setPhotoModalOpen(false);
const handleDeleteEmployee = async (id) => {
  try {
    setLoading(true)
    const response = await api.put(
      "/v1/onboarding-employee/soft-delete",
      null,
      {
        params: { id },
      }
    );
 if (response.status === 200) {
    setToastMessage("Employee deleted successfully.");
    setToastSeverity("success");
    setOpenToast(true);
  } else {
    setToastMessage(response?.message||"Unable to delete employee. Please try again.");
    setToastSeverity("info");
    setOpenToast(true);
  }
  } catch (error) {
      if (error.response) {
    setToastMessage(
      error.response.data?.message ||
      "Failed to delete employee. Server error."
    );
  } else if (error.request) {
    setToastMessage("Network error. Please check your internet connection.");
  } else {
    setToastMessage("Something went wrong. Please try again.");
  }
    console.error(error);
  }finally{
    setLoading(false)
    
  

    fetchData();
  }
};
useEffect(() => {
  if (selectedFilter) {
    if (selectedFilter.field === "id") {
      setFilteredEmployees(
        employees.filter(
          (e) => String(e.emp_id).trim() === String(selectedFilter.value).trim()
        )
      );
    } else if (selectedFilter.field === "name") {
      setFilteredEmployees(
        employees.filter(
          (e) =>
            `${e.employee_details?.firstname || ""} ${e.employee_details?.lastname || ""}`
              .toLowerCase()
              .trim() === selectedFilter.value.toLowerCase().trim()
        )
      );
    } else if (selectedFilter.field === "company") {
      setFilteredEmployees(
        employees.filter(
          (e) =>
            String(e.employee_details?.company_id).trim() === String(selectedFilter.value).trim()
        )
      );
    }
  } else {
    setFilteredEmployees(employees);
  }
  setCurrentPage(1);
}, [selectedFilter, employees]);



  // pagination logic
  const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);
  const startIdx = (currentPage - 1) * rowsPerPage;
  const currentEmployees = filteredEmployees.slice(
    startIdx,
    startIdx + rowsPerPage
  );

  // suggestions
  const suggestions =
  activeSearchField === "id"
    ? employees
        .filter((e) =>
          String(e.emp_id).toLowerCase().includes(searchId.toLowerCase())
        )
        .slice(0, 5)
    : activeSearchField === "name"
    ? employees
        .filter((e) =>
          `${e.employee_details?.firstname || ""} ${
            e.employee_details?.lastname || ""
          }`
            .toLowerCase()
            .includes(searchName.toLowerCase())
        )
        .slice(0, 5)
    : [];

  return (
    <SideNavLayout>
      <div className="p-6  max-h-[90vh] overflow-auto custom-scrollbar ">
        {/* Header Section */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-6">
            <h1 className="text-xl font-semibold text-gray-900">
              Employee Onboarding
            </h1>
            <button
              onClick={() => {
                navigate("/onboarding");
              }}
              className="px-2 py-1 border border-[#8C8C8C] text-[#8C8C8C] rounded-md shadow-sm bg-white text-xs font-medium flex items-center gap-1"
            >
              {plusicongrey} Onboard
            </button>
          </div>

          <div className="flex items-center gap-4">
            {/* Company Dropdown */}
            <select
              value={
                selectedFilter?.field === "company" ? selectedFilter.value : ""
              }
              onChange={(e) => {
                if (e.target.value) {
                  setSelectedFilter({ field: "company", value: e.target.value });
                } else {
                  setSelectedFilter(null);
                }
              }}
              className="border-2 border-[#E4E4E7] rounded-md px-3 py-2 bg-white text-sm text-black"
            >
              <option value="">All Companies</option>
              {companyies.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>

            {/* Date Selector */}
            <div className="relative" ref={pickerRef}>
              <button
                onClick={() => setShowPicker(!showPicker)}
                className="flex items-center gap-2 border-2 border-[#E4E4E7] rounded-md px-3 py-2 bg-white text-sm text-black"
              >
                {calendericonblack}
                <span>
                  {historyCalendar
                    ? `${dayjs(historyCalendar[0].startDate).format(
                        "MMM D, YYYY"
                      )} - ${dayjs(historyCalendar[0].endDate).format(
                        "MMM D, YYYY"
                      )}`
                    : "Select Date"}
                </span>
              </button>

              {showPicker && (
                <div className="absolute right-0 mt-2 z-50 shadow-lg border rounded-md bg-white">
                  <DateRangePicker
                    onChange={(item) => setSelectionRange([item.selection])}
                    ranges={selectionRange}
                    moveRangeOnFirstSelection={false}
                    maxDate={new Date()}
                  />

                  <div className="flex justify-end gap-2 p-3 border-t bg-gray-50">
                    <button
                      onClick={handleReset}
                      className="px-3 py-1 text-sm border rounded-md text-gray-600 hover:bg-gray-100"
                    >
                      Reset
                    </button>
                    <button
                      onClick={handleApply}
                      className="px-3 py-1 text-sm rounded-md bg-[#8B1818] text-white hover:bg-[#701313]"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      {selectedFilter && (
  <div className="mb-4 flex gap-2">
    <div className="flex items-center gap-2 bg-gray-200 px-3 py-1 rounded-full text-sm">
      <span>
        {selectedFilter.field === "id"
          ? "EMPLOYEE ID"
          : selectedFilter.field === "name"
          ? "NAME"
          : "COMPANY"}:{" "}
        {selectedFilter.field === "company"
          ? companyies.find(
              (c) => String(c.id) === String(selectedFilter.value)
            )?.name || selectedFilter.value
          : selectedFilter.value}
      </span>
      <button
        onClick={() => {
          setSelectedFilter(null);
          setSearchId("");
          setSearchName("");
          setActiveSearchField(null);
        }}
        className="text-gray-600 hover:text-gray-900"
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  </div>
)}


        {/* Table */}
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-6 py-5 font-semibold text-[#8B1818]">
                  <div className="flex flex-col">
                    <div className="flex items-center gap-1">
                      EMPLOYEE ID
                      <button
                        onClick={() =>
                          setActiveSearchField(
                            activeSearchField === "id" ? null : "id"
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                    {activeSearchField === "id" && (
                      <div className="relative">
                        <input
                          type="text"
                          value={searchId}
                          onChange={(e) => setSearchId(e.target.value)}
                          placeholder="Search By ID..."
                          className="w-full text-xs p-1 border bg-transparent border-transparent rounded 
             focus:outline-none focus:border-[#8B1818] focus:ring-1 focus:ring-[#8B1818]"
                        />

                        {searchId && suggestions.length > 0 && (
                          <div className="absolute z-10 bg-white shadow rounded border mt-1 w-full">
                            {suggestions.map((s, i) => (
                              <div
                                key={i}
                                onClick={() => {
                                  setSelectedFilter({
                                    field: "id",
                                    value: s.emp_id,
                                  });
                                  setActiveSearchField(null);
                                  setSearchId("");
                                }}
                                className="px-2 py-1 hover:bg-gray-100 cursor-pointer text-sm"
                              >
                                {s.emp_id}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </th>
                <th className="px-6 py-5 font-semibold text-[#8B1818]">
                  <div className="flex flex-col">
                    <div className="flex items-center gap-1">
                      NAME
                      <button
                        onClick={() =>
                          setActiveSearchField(
                            activeSearchField === "name" ? null : "name"
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </button>
                    </div>
                    {activeSearchField === "name" && (
                      <div className="relative">
                        <input
                          type="text"
                          value={searchName}
                          onChange={(e) => setSearchName(e.target.value)}
                          placeholder="Search By Name"
                          className="w-full text-xs p-1 border bg-transparent border-transparent rounded 
             focus:outline-none focus:border-[#8B1818] focus:ring-1 focus:ring-[#8B1818]"
                        />
                        {searchName && suggestions.length > 0 && (
                          <div className="absolute z-10 bg-white shadow rounded border mt-1 w-full">
                            {suggestions.map((s, i) => {
                              const fullName = `${s.employee_details?.firstname || ""} ${
                                s.employee_details?.lastname || ""
                              }`;
                              return (
                                <div
                                  key={i}
                                  onClick={() => {
                                    setSelectedFilter({
                                      field: "name",
                                      value: fullName,
                                    });
                                    setActiveSearchField(null);
                                    setSearchName("");
                                  }}
                                  className="px-2 py-1 hover:bg-gray-100 cursor-pointer text-sm"
                                >
                                  {fullName}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </th>
                <th className="px-6 py-5 font-semibold text-[#8B1818]">
                  DATE &amp; TIME
                </th>
                <th className="px-6 py-5 font-semibold text-[#8B1818]">
                  DEPARTMENT
                </th>
                <th className="px-6 py-5 font-semibold text-[#8B1818]">ACTION</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentEmployees.length > 0 ? (
                currentEmployees.map((emp, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="px-6 py-4">{emp.emp_id}</td>
                    <td className="px-6 py-4">
                      {`${emp.employee_details?.firstname || ""} ${
                        emp.employee_details?.lastname || ""
                      }`}
                    </td>
                    <td className="px-6 py-4">
                      {dayjs(emp.created_at).format("MM/DD/YYYY hh:mm A")}
                    </td>
                    <td className="px-6 py-4">
                      {companyies.find(
                        (c) => c.id === Number(emp.employee_details?.company_id)
                      )?.name || "-"}
                    </td>
                   <td className="px-6 py-4">
  <div className="flex items-center gap-2">
      <Tooltip title="View photos" arrow>

 <button
      onClick={() => handleOpenPhotos(emp.employee_images)}
      className="w-9 h-9 flex items-center justify-center rounded-full bg-[#4B5563] text-white"
    >
      {eyeiconwhite}
    </button>
      </Tooltip>
     <Tooltip title="Re-enroll employee" arrow>
   <button
  onClick={() => {
    const params = new URLSearchParams({
      id: emp.id,
      emp_id: emp.emp_id,
      orgId: emp.employee_details.company_id,
    });

    navigate(`/enroll?${params.toString()}`);
  }}
      className="w-9 h-9 flex items-center justify-center rounded-full bg-[#4B5563] text-white"
    >
      <RefreshIcon sx={{ fontSize: "18px" }} />
    </button>

     </Tooltip>

<Tooltip title="Delete employee" arrow>
  <button
    onClick={() => {
      setDeleteEmployeeId(emp.id);
      setDeleteModalOpen(true);
    }}
    className="w-9 h-9 flex items-center justify-center rounded-full bg-[#DC2626] text-white hover:bg-[#B91C1C]"
  >
    <DeleteIcon sx={{ fontSize: 18 }} />
  </button>
</Tooltip>

  </div>
</td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    {loading ? "Getting Records ..." : " No records found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredEmployees.length > 5 && (
          <div className="flex items-center justify-between mt-4">
            {/* Rows per page */}
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-700">Rows per page:</span>
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border rounded-md px-2 py-1 text-sm"
              >
                {[5, 10,15, 20, 50].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div>

            {/* Page controls */}
            <div className="flex items-center gap-4 text-sm">
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <div className="flex gap-2">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-4 py-2 rounded-lg border text-sm font-medium 
                     bg-white text-gray-700 hover:bg-gray-100 
                     disabled:opacity-40 disabled:cursor-not-allowed 
                     transition"
                >
                  ← Previous
                </button>

                <button
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 rounded-lg border text-sm font-medium 
                     bg-white text-gray-700 hover:bg-gray-100 
                     disabled:opacity-40 disabled:cursor-not-allowed 
                     transition"
                >
                  Next →
                </button>
              </div>
            </div>
          </div>
        )}
<ToastMessage
        message={toastMessage} 
        severity={toastSeverity} 
        open={openToast} 
        handleClose={handleCloseToast} 
      />
      <DeleteConfirmModal
  open={deleteModalOpen}
  onCancel={() => {
    setDeleteModalOpen(false);
    setDeleteEmployeeId(null);
  }}
  onConfirm={() => {
    handleDeleteEmployee(deleteEmployeeId);
    setDeleteModalOpen(false);
    setDeleteEmployeeId(null);
  }}
/>

        <EmployeePhotoModal
          open={photoModalOpen}
          onClose={handleClosePhotos}
          images={selectedPhotos}
        />

        {/* Backdrop Loader */}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </SideNavLayout>
  );
};

export default OnBoardingView;
